import * as React from "react";
import {useEffect} from "react";

import {useGuideState} from "@khan/guide-state";
import {ReferencesContext} from "@khan/slate-contexts";

export const useReferences = ({
    enabled,
    injectTextDisabled,
}: {
    enabled: boolean | undefined;
    injectTextDisabled: boolean;
}) => {
    const references = React.useContext(ReferencesContext);
    const isReferencesActive =
        !!references.query.range && references.filteredReferenceList.length > 0;
    const selectedBotName = useGuideState("selectedBotName");

    useEffect(() => {
        // prevents this from being called while parent is still rendering
        references.setDisabled(
            injectTextDisabled ||
                (selectedBotName != null &&
                    !references.enabledConfigs?.has(selectedBotName)),
        );
    }, [references, injectTextDisabled, selectedBotName]);

    return {
        references,
        isReferencesActive,
        showReferencesList:
            references.showButton && !references.disabled && isReferencesActive,
        showReferencesButton: enabled && references.showButton,
    };
};
